<template>
    <div v-if="text || hasDefaultSlot">
        <alert class="bg-yellow-50">
            <template #icon>
                <svg class="h-6 w-6 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                </svg>
            </template>
            <template #text>
                <div v-if="hasDefaultSlot" class="text-yellow-800"><slot></slot></div>
                <p v-if="!hasDefaultSlot" class="text-yellow-800">{{ text }}</p>
            </template>
            <template #link>
                <slot name="link"></slot>
            </template>
        </alert>
    </div>
</template>

<script>
import Alert from './Alert';

export default {
    components: {Alert},

    props: ['alert'],

    computed: {
        hasDefaultSlot(){
            return !!this.$slots.default;
        },
        text() {
            if(!this.alert) return null;
            return this.alert.success;
        }
    }
}
</script>